import { useCallback, useEffect } from 'react';
import { useSafeFocusEffect, useSafeNavigation } from '@sg/garnish';

/**
 * We are disabling gestures when the animated dialog is shown, as we don't want users to dismiss the bag when attempting to dismiss it.
 * When the screen is unfocused, we re-enable the gestures so it doesn't break other screens in the modal stack.
 */
export const useBagGestures = (isShowingModal: boolean) => {
  const navigation = useSafeNavigation();

  useEffect(() => {
    navigation?.getParent()?.setOptions({ gestureEnabled: !isShowingModal });
  }, [navigation, isShowingModal]);

  useSafeFocusEffect(
    useCallback(() => {
      return () => {
        navigation?.getParent()?.setOptions({ gestureEnabled: true });
      };
    }, [navigation]),
  );
};
